import {
    addressWithoutPOBox,
    isState,
    postalCodeUS,
} from '@/components/Helpers/validationHelpers.ts';
import type {TFunction} from 'i18next';
import moment from 'moment/moment';
import {z} from 'zod';

export const form500Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        livingSituation: z.string({message: `${t('requiredErrorFull')}`}),
        leaseExpires: z
            .custom<moment.Moment | undefined>(
                val => {
                    return moment.isMoment(val);
                },
                {message: 'Invalid Date'},
            )
            .nullish(),
        address: addressWithoutPOBox(`${t('sef500Address')} ${t('requiredError')}`),
        city: z.string({message: `${t('sef500City')} ${t('requiredError')}`}),
        state: isState.nullable(),
        zip: postalCodeUS(`${t('sef203GuardianZip')} is required.`).nullable(),
    });

export const form500Refine = (
    schema: ReturnType<typeof form500Schema>,
    t: TFunction<'translation', undefined>,
) => {
    return schema.refine(
        formData => {
            return formData.livingSituation === 'Renter' ? formData.leaseExpires?.isValid() : true;
        },
        {
            message: `${t('sef500LeaseExpires')} is required.`,
            path: ['leaseExpires'],
        },
    );
};
